<template>
  <div>
    <header-bar>登録情報</header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">アカウント情報 - ご契約プラン詳細</h3>
      </div>
      <div class="page-block__inner">
        <div class="profile_change_settlement-area">
          <div class="profile_change_settlement-area__text">
            {{ pagination.data.length? 'ご利用明細' : 'まだ、ご利用がありません' }}
          </div>
        </div>
        <div
          v-if="pagination.data.length"
          class="c-table-caption">
          横にスクロールしてご覧ください
        </div>
        <div
          v-if="pagination.data.length"
          class="settlement-plan-list">
          <table class="settlement-plan-list__table">
            <thead class="settlement-plan-list__thead">
              <tr>
                <th>ID</th>
                <th>日付</th>
                <th>プラン</th>
                <th>決済手段</th>
                <th>金額</th>
              </tr>
            </thead>
            <tbody class="settlement-plan-list__tbody">
              <tr
                v-for="item in pagination.data"
                :key="item.id">
                <td
                  class="u-text-align-left wrap"
                  style="word-wrap: break-word;">
                  {{ item.contact_no }}
                </td>
                <td>{{ item.created_at | formatDate('YYYY.MM.DD') }}</td>
                <td>{{ item.summary }}</td>
                <td>{{ item.settlement_method.name }}</td>
                <td>{{ item.amount }}円</td>
              </tr>
            </tbody>
          </table>
          <pagination
            :pagination="pagination"
            @on-pagination-clicked="fetchItems">
          </pagination>
        </div>
        <div class="c-btn-wrap">
          <router-link
            :to="{ name: 'profile' }"
            class="c-btn c-btn--back">
            戻る<span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderBar from '../HeaderBar'
import Pagination from '../../../components/Pagination'

export default {
  components: {
    HeaderBar,
    Pagination,
  },
  data() {
    return {
      pagination: {},
    }
  },
  mounted() {
    if (!this.isBtoC) this.$router.push('/client/user/profile')
    this.fetchItems()
  },
  methods: {
    async fetchItems(page = 1) {
      const { data } = await window.axios.get('/api/client/settlements', {
        params: {
          page,
        },
      })
      this.pagination = data
    },
  },
}
</script>
